import Vue from 'vue';
import Component from 'vue-class-component';
import { Model, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'LoaderBtn'
})
// eslint-disable-next-line unicorn/prevent-abbreviations
export default class LoaderBtn extends Vue {
    @Prop({ default: null }) readonly loading!: boolean | null;
    @Prop({ default: 'Saving' }) readonly loadingText!: string;
    @Model('change') readonly status!: boolean;

    // eslint-disable-next-line @typescript-eslint/ban-types
    clickHandler: Function | null = null;
    waitingPromise = false;

    get _loading() {
        return this.loading || this.waitingPromise;
    }

    @Watch('loading')
    onLoadingChange() {
        this.$emit('change', this._loading);
    }

    @Watch('waitingPromise', { immediate: true })
    onWaitingPromiseChange() {
        this.$emit('change', this._loading);
    }

    created() {
        // Remove any click listener, we will intercept it
        if (this.$listeners['click']) {
            this.clickHandler = Array.isArray(this.$listeners['click'])
                ? this.$listeners['click'][0]
                : this.$listeners['click'];
        }
    }

    async handleClick(event: MouseEvent) {
        const result = this.clickHandler && this.clickHandler(event);

        // If the click handler returns a promise, set the loading state based on the promise
        //  promise status
        if (this.loading === null && result instanceof Promise) {
            this.waitingPromise = true;

            try {
                await result;
                this.waitingPromise = false;
            } catch (error) {
                this.waitingPromise = false;
                throw error;
            }
        }
    }
}
